export const SET_ACTIVE_EMAIL = 'SET_ACTIVE_EMAIL'
export const SET_ACTIVE_USER = 'SET_ACTIVE_USER'
export const SET_INBOX_EMAIL = 'SET_INBOX_EMAIL'
export const SET_SENT_EMAIL = 'SET_SENT_EMAIL'
export const SET_TRASH_EMAIL = 'SET_TRASH_EMAIL'
export const SET_INBOX_PAGE_TOKEN = 'SET_INBOX_PAGE_TOKEN'
export const SET_SENT_PAGE_TOKEN = 'SET_SENT_PAGE_TOKEN'
export const SET_TRASH_PAGE_TOKEN = 'SET_TRASH_PAGE_TOKEN'
export const SET_ATTACHMENTS_LIST = 'SET_ATTACHMENTS_LIST'
export const SET_ATTACHMENTS_ZIP = 'SET_ATTACHMENTS_ZIP'
export const SET_NEW_MESSAGE = 'SET_NEW_MESSAGE'
export const SET_GMAIL_API = 'SET_GMAIL_API'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_TEMPLATES_LIST = 'SET_TEMPLATES_LIST'
export const SET_TEMPLATES_SETTINGS = 'SET_TEMPLATES_SETTINGS'
export const SET_FOLDERS_LIST = 'SET_FOLDERS_LIST'
export const SET_CURRENT_FOLDER = 'SET_CURRENT_FOLDER'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const SET_DRAGGED_TEMPLATE = 'SET_DRAGGED_TEMPLATE'
export const SET_CONTACT_LIST_MAIL = 'SET_CONTACT_LIST_MAIL'
export const SET_SEND_AS_EMAILS = 'SET_SEND_AS_EMAILS'
export const SET_SERVICE_ACCOUNT_TOKENS = 'SET_SERVICE_ACCOUNT_TOKENS'
export const SET_CONFIG_API_KEYS = 'SET_CONFIG_API_KEYS'
export const SET_SAVED_EMAIL = 'SET_SAVED_EMAIL'
export const SET_TODO_EMAIL = 'SET_TODO_EMAIL'
export const SET_SAVED_PAGE_TOKEN = 'SET_SAVED_PAGE_TOKEN'
export const SET_TODO_PAGE_TOKEN = 'SET_TODO_PAGE_TOKEN'
export const SET_TAG_LIST = 'SET_TAG_LIST'
export const SET_USER_LIST_MAIL = 'SET_USER_LIST_MAIL'
export const SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE'
export const SET_EMAIL_REPORTS_LIST = 'SET_EMAIL_REPORTS_LIST'
export const SET_DRAFT_EMAIL = 'SET_DRAFT_EMAIL'
export const SET_UPDATE_THREAD_STORE = 'SET_UPDATE_THREAD_STORE'
export const SET_EMAIL_STORE = 'SET_EMAIL_STORE'
export const SET_DRAFT_PAGE_TOKEN = 'SET_DRAFT_PAGE_TOKEN'



// WEBPACK FOOTER //
// ./src/constants/mutationTypes.js